export default __webpack_public_path__ + "8ee11e48bc774829447cd3235887e125.jpg";